<template>
  <div>
    <v-icon @click="abrirDialog" size="14" class="cursor-pointer">mdi-pencil</v-icon>

    <SysDialog
      v-model="dialog_ativo"
      titulo="Ressuprimento manual"
      :largura="!apenas_produto_selecionado ? 800 : 600"
      @click:primary="salvarRessuprimento"
      @click:hidden-dialog="fecharDialog"
    >
      <v-radio-group v-model="apenas_produto_selecionado" v-if="!produto.produto_eh_combinacao">
        <v-radio :value="true">
          <template #label>
            <span class="ml-1">Aplicar apenas no produto selecionado</span>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template #label>
            <span class="ml-1">Aplicar através de filtros</span>
          </template>
        </v-radio>
      </v-radio-group>

      <DivisorComLegenda v-if="!apenas_produto_selecionado" legenda="Filtros" class="mb-5" />

      <BlocoFiltrosPrincipais v-show="!apenas_produto_selecionado" :filtros="filtros" ocultar_filtro_filiais />

      <DivisorComLegenda v-if="!apenas_produto_selecionado" legenda="Parâmetros" class="mb-5 mt-2" />

      <v-switch v-model="ressuprimento_manual_ativo">
        <template #label>
          <span class="ml-3">Ativar ressuprimento manual</span>
        </template>
      </v-switch>

      <TextFieldFormatadorDeValor
        v-model="qtde_dias_tempo_ressuprimento"
        label="Informe o tempo de ressuprimento"
        outlined
        inteiro
        suffix="dias"
        :disabled="!ressuprimento_manual_ativo"
        :error-messages="RESSUPRIMENTO_ERROS"
        @focus="$event.target.select()"
        @keypress.enter="salvarRessuprimento()"
      />
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor";
import {required} from "vuelidate/lib/validators";
import {salvarTempoRessuprimento} from "@/api/compraPorProdutosGerais/Produtos";
import {logout} from "@/helpers";
import BlocoFiltrosPrincipais from "@/components/compra/ProdutosGerais/Filtros/BlocoFiltrosPrincipais";
import DivisorComLegenda from "@/components/utils/DivisorComLegenda";

export default {
  name: "Ressuprimento",
  components: {
    DivisorComLegenda,
    BlocoFiltrosPrincipais,
    TextFieldFormatadorDeValor,
    SysDialog
  },
  props: {
    produto: Object
  },
  data: () => ({
    dialog_ativo: false,
    apenas_produto_selecionado: true,
    qtde_dias_tempo_ressuprimento: 0,
    filtros: {
      grupos: [],
      filiais: [],
      segmentos: [],
      secoes: [],
      categorias: [],
      linhas: [],
      compradores: [],
      fornecedores: [],
      marcas: [],
    },
    ressuprimento_manual_ativo: false
  }),
  validations: {
    qtde_dias_tempo_ressuprimento: {
      required,
      minValue: function () {
        if (this.ressuprimento_manual_ativo) {
          return this.qtde_dias_tempo_ressuprimento > 1;
        }

        return true;
      }
    }
  },
  computed: {
    RESSUPRIMENTO_ERROS() {
      const errors = [];
      if (!this.$v.qtde_dias_tempo_ressuprimento.$dirty) return errors;
      !this.$v.qtde_dias_tempo_ressuprimento.required && errors.push("Campo Obrigatório.");
      !this.$v.qtde_dias_tempo_ressuprimento.minValue && errors.push("Insira um valor inteiro.");
      return errors;
    },
    FILTROS_STORE() {
      return this.$store.getters['CompraProdutosGerais/getFiltros'];
    }
  },
  watch: {
    ressuprimento_manual_ativo() {
      if (!this.ressuprimento_manual_ativo) {
        this.$v.$reset();
        this.qtde_dias_tempo_ressuprimento = 0;
      } else {
        this.$v.$reset();
        this.qtde_dias_tempo_ressuprimento = this.produto.qtde_dias_tempo_ressuprimento;
      }
    },
    apenas_produto_selecionado() {
      this.setFiltros();
    }
  },
  methods: {
    salvarRessuprimento() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const parametros = {
        filtros: this.filtros,
        produto: this.produto.id_produto,
        produto_eh_combinacao: this.produto.produto_eh_combinacao,
        ressuprimento_manual_ativo: this.ressuprimento_manual_ativo,
        qtde_dias_tempo_ressuprimento: parseInt(this.qtde_dias_tempo_ressuprimento),
        apenas_produto_selecionado: this.apenas_produto_selecionado,
      };

      this.$store.dispatch('loading/addRequisicao',
        salvarTempoRessuprimento(parametros)
          .then(() => {
            this.$emit("update:tempo-ressuprimento", {});
            this.fecharDialog();
          })
          .catch(logout)
      );
    },
    abrirDialog() {
      this.dialog_ativo = ! this.dialog_ativo;
      this.setFiltros();

      if (this.produto.ressuprimento_manual_ativo) {
        this.apenas_produto_selecionado = true;
        this.ressuprimento_manual_ativo = true;
        this.qtde_dias_tempo_ressuprimento = this.produto.qtde_dias_tempo_ressuprimento;
      }
    },
    setFiltros() {
      if (this.apenas_produto_selecionado) {
        this.filtros.grupos = [this.produto.id_grupo];
      } else {
        this.filtros.grupos = this.FILTROS_STORE.grupos;
        this.filtros.segmentos = this.FILTROS_STORE.segmentos;
        this.filtros.secoes = this.FILTROS_STORE.secoes;
        this.filtros.compradores = this.FILTROS_STORE.compradores;
        this.filtros.fornecedores = this.FILTROS_STORE.fornecedores;

      }
    },
    fecharDialog() {
      this.$v.$reset();
      this.dialog_ativo = false;
      this.apenas_produto_selecionado = true;
      this.ressuprimento_manual_ativo = false;
      this.qtde_dias_tempo_ressuprimento = 0;
    }
  }
}
</script>

<style scoped>

</style>
